import CommentItem from "./commentsItem";



 const CommentsList = ({ comments, likedComments, onLike }) => (
  <>
    {comments.map((comment) => (
      <div key={comment.id} className="mb-1">
        <CommentItem
          comment={comment}
          onLike={onLike}
          isLiked={likedComments.has(comment.id)}
        />
        {comment.replies?.map((reply) => (
          <CommentItem
            key={reply.id}
            comment={reply}
            isReply={true}
            onLike={onLike}
            isLiked={likedComments.has(reply.id)}
          />
        ))}
      </div>
    ))}
  </>
);

export default CommentsList
